import api from './api';

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    const { accessToken, refreshToken, user } = response.data.data;
    
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    
    return user;
  },
  
  async register(data) {
    const response = await api.post('/auth/register', data);
    const { accessToken, refreshToken, user } = response.data.data;
    
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    
    return user;
  },
  
  async logout() {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    }
  },
  
  async getMe() {
    const response = await api.get('/auth/me');
    return response.data.data;
  },
  
  async updateProfile(data) {
    const response = await api.patch('/auth/profile', data);
    return response.data.data;
  },
  
  async updateAvatar(file) {
    const formData = new FormData();
    formData.append('avatar', file);
    
    const response = await api.patch('/auth/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.data;
  },
  
  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      password: newPassword
    });
    return response.data;
  },
  
  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },
  
  async resetPassword(token, password) {
    const response = await api.post('/auth/reset-password', { token, password });
    return response.data;
  },
  
  async verifyEmail(token) {
    const response = await api.post('/auth/verify-email', { token });
    const { accessToken, refreshToken } = response.data.data;
    
    if (accessToken && refreshToken) {
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
    }
    
    return response.data;
  },
  
  async resendVerification(email) {
    const response = await api.post('/auth/resend-verification', { email });
    return response.data;
  },
  
  async getCountries() {
    const response = await api.get('/auth/countries');
    return response.data;
  }
};
